/** Presenter entry creates a clean owned room. Audience links go directly to /join/:token. */
import { useState, useRef } from 'react';
import { Link, useNavigate } from '../shell/router.tsx';
import { createSession } from '../api.ts';
import { HOST_SESSION_KEY, loadHostCredentials, saveCredentials } from '../session/credentials.ts';
import boardArtwork from '../../../../assets/board/previews/section-v2.png';
import './uniplay-entry.css';
export function MomentumEntry() {
  const navigate = useNavigate();
  const [starting, setStarting] = useState(false);
  const [error, setError] = useState('');
  const creating = useRef(false);
  let savedHost: string | null = null;
  try { const id = localStorage.getItem(HOST_SESSION_KEY); if (id && loadHostCredentials(id)) savedHost = id; } catch { /* Storage optional. */ }
  async function startFresh() {
    if (creating.current) return;
    creating.current = true; setStarting(true); setError('');
    try {
      const response = await createSession({displayName:'Christoffer',characterSlot:'coral-triangle',hostIsPlayer:true,settings:{voiceMode:'remote'}});
      saveCredentials(response.sessionId, response.participant);
      try { localStorage.setItem(HOST_SESSION_KEY, response.sessionId); } catch { /* Tab credential remains available. */ }
      navigate(`/s/${response.sessionId}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not start. Please try again.');
      creating.current = false; setStarting(false);
    }
  }
  return <main className="momentum-entry">
    <img className="momentum-entry-hero" src={boardArtwork} alt="The Momentum game board" />
    <div className="momentum-entry-layout"><div>
      <span className="momentum-entry-kicker">A team game · Prototype</span><h1>Momentum</h1>
      <p>Small choices. Shared challenges.<br/>See where your team takes you.</p>
      <div className="momentum-entry-actions">
        <button className="button button-primary" disabled={starting} onClick={() => void startFresh()}>{starting ? 'Opening your fresh lobby…' : 'Start fresh as host'}</button>
        {savedHost ? <Link className="button" to="/host">Resume previous room</Link> : null}
      </div>
      <p className="momentum-entry-feedback">You’ll be Christoffer, the host. Then play with NPCs or invite your team.</p>
      {error ? <p role="alert">{error}</p> : null}
    </div></div>
    <footer className="momentum-entry-footer">Momentum concept experience</footer>
  </main>;
}
